


<a href="https://api.whatsapp.com/send/?phone=%2B593993183975&text&type=phone_number&app_absent=0" class="float-wa" target="_blank">
  <i class="fa fa-whatsapp" style="margin-top:13px;"></i>
</a>
